<template>
    <rkm-sidebar :open="open">
        <rkm-sidebar-list class="mt-2">
            <rkm-list-group>
                <rkm-sidebar-list-group-item
                    :active="$route.name && $route.name.includes('dashboard')"
                    :to="{name: 'dashboard'}"
                    icon="home"
                    title="Dashboard"
                />

                <rkm-sidebar-list-group
                    v-for="(modulo) in modulos"
                    v-bind:key="modulo.id"
                >
                    <rkm-sidebar-list-group-item
                        :active="$route.name && $route.name.includes(modulo.prefixo)"
                        :icon="modulo.icone"
                        :title="modulo.nome"
                        v-rkm-toggle="`modulo-${modulo.id}`"
                    />
                    
                    <rkm-sidebar-list
                        :id="`modulo-${modulo.id}`"
                        :visible="$route.name && $route.name.split('-').shift() === modulo.prefixo"
                        accordion="funcionalidades"
                        sub-group
                    >
                        <rkm-sidebar-list-group
                            v-for="(funcionalidade) in modulo.funcionalidades"
                            v-bind:key="funcionalidade.id"
                        >
                            <rkm-sidebar-list-group-item
                                :active="$route.name && $route.name.includes(funcionalidade.prefixo)"
                                :title="funcionalidade.nome"
                                :to="{name: `${modulo.prefixo}-${funcionalidade.prefixo}`}"
                            />
                        </rkm-sidebar-list-group>
                    </rkm-sidebar-list>
                </rkm-sidebar-list-group>
            </rkm-list-group>
        </rkm-sidebar-list>

        <div class="footer">
            <div>ConectaCidadão ⋅ {{others.moment(datetime).format('YYYY')}}</div>
            <div>
                <rkm-icon :icon="['far', 'clock']" /> {{others.moment(datetime).format('DD/MM/YYYY HH:mm\\h')}}
            </div>
        </div>
    </rkm-sidebar>
</template>

<script>
// Others.
import moment from 'moment'

// Vuex
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({datetime: 'getDatetime'}),
        ...mapGetters({modulos: 'getModulos'}),
    },
    data: () => ({
        others: {moment},
    }),
    props: {
        open: {type: Boolean},
    },
}
</script>

<style scoped>
.footer {
    background: rgba(0,0,0,0.1);
    border-radius: 100px;
    display: flex;
    flex-direction: column;
    height: 60px;
    justify-content: space-evenly;
    margin: 0.75rem;
    padding: 1rem;
    text-align: center;
}
</style>